import React from 'react';
import Proptypes from 'prop-types';
import _ from 'lodash';
import { FRAME_SCALE_LINEAR, FRAME_SCALE_LOG, AVERAGE_BUFFER_FRAME_TYPE, AVERAGE_SAMPLE_FRAME_TYPE, SUBTRACTED_FRAME_TYPE, BUFFER_OR_SAMPLE_FRAME_TYPE } from '../../../constants/saxs';
import { getPlottingDataByFramePromise } from './IORequests';

/**
 * React container able to retrieve the csv data for a list of frames. 
 */
class SaxsFrameListPlotterContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            framesWithCSV: [], // present and past requested frame objects enriched with csvdata.
            fetching: true,
            fetched: false,
            scale: null,
        }

        this.getPlottingData = this.getPlottingData.bind(this);
        this.getScale = this.getScale.bind(this);
    }

    render() {
        if (this.props.scale !== this.state.scale) {
            this.getPlottingData(this.props.frames);
        } else {
            let framesNotAlreadyInState = _.isEqual(this.props.frames, this.state.framesWithCSV);
            if (framesNotAlreadyInState === false) {
                this.getPlottingData(this.props.frames);
            }
        }
        return this.props.children(this.state.framesWithCSV);
    }

    /**
     * Get CSV data 
     * @param {*} frames frame list for which csv data is needed. The frames are not yet in the state.
     */
    getPlottingData(frames) {
        let { token } = this.props;

        let promises = [];
        frames.forEach(frame => {
            if (frame && frame.type) {
                let frameId = '';
                let averageId = '';
                let subtractedId = '';
                let sampleAverageId = '';
                let bufferAverageId = '';
                let models = '';
                let operation = this.getScale();
                if (frame.type === BUFFER_OR_SAMPLE_FRAME_TYPE) { frameId = frame.frameId };
                if (frame.type === AVERAGE_BUFFER_FRAME_TYPE) { bufferAverageId = frame.frameId }
                if (frame.type === AVERAGE_SAMPLE_FRAME_TYPE) { sampleAverageId = frame.frameId }
                if (frame.type === SUBTRACTED_FRAME_TYPE) { subtractedId = frame.frameId }
                promises.push(getPlottingDataByFramePromise(token, frame, frameId, averageId, subtractedId, sampleAverageId, bufferAverageId, models, operation))
            }
        });

        Promise.all(promises)
            .then(
                results => {
                    if (results) { // results = An array which items have the form {response: response, frame: frameObject }
                        let framesWithCSV = [];
                        results.forEach(element => {
                            let frame = element.frame;
                            frame.csvData = element.response.data;
                            framesWithCSV.push(frame);
                        });
                        this.setState({ framesWithCSV: framesWithCSV, scale: this.props.scale });
                    }
                }
            ).catch(error => {
                debugger
            })
    }

    /** Get the Y-axis scale */
    getScale() {
        let { scale } = this.props;
        if (scale) {
            if (scale === FRAME_SCALE_LINEAR) { return 'LINEAL' }
            if (scale === FRAME_SCALE_LOG) { return 'LOG' }
        }
        return null;
    }
}

export default SaxsFrameListPlotterContainer;

SaxsFrameListPlotterContainer.proptypes = {
    /**  the frame list to be displayed*/
    frames: Proptypes.object,
    /** scale on Y axis: FRAME_SCALE_LINEAR or FRAME_SCALE_LOG */
    scale: Proptypes.string,
    /** Ispyb authentication token */
    token: Proptypes.string,
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsFrameListPlotterContainer.js